import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  private activeDropdownSubject = new BehaviorSubject<string | null>(null);

  setActiveDropdown(dropdownName: string | null) {
    this.activeDropdownSubject.next(dropdownName);
  }

  getActiveDropdown() {
    return this.activeDropdownSubject.asObservable();
  }

  getCurrentDropdown(): string | null {
    return this.activeDropdownSubject.getValue();
  }
}
